/**
 * Handle Auth0 initialization in PWA standalone mode
 * Ensures auth module initializes properly and doesn't hang
 */
export default function ({ app, route, redirect }, inject) {
  if (typeof window === 'undefined') {
    return
  }

  // Check if running in PWA standalone mode
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                      window.navigator.standalone ||
                      document.referrer.includes('android-app://')

  if (!isStandalone) {
    return
  }

  console.log('[Auth PWA] Running in standalone mode')

  // Initialize auth check with timeout
  const initAuthCheck = () => {
    // Wait for auth module to be available
    const checkAuth = setInterval(() => {
      if (app.$auth) {
        clearInterval(checkAuth)
        
        // Check auth state after a short delay
        setTimeout(() => {
          try {
            // If not logged in and not on auth pages, redirect to login
            if (!app.$auth.loggedIn) {
              const authPages = ['/auth/login/', '/auth/callback/', '/auth/logout/', '/auth/unavailable/']
              const currentPath = route.path
              
              if (!authPages.includes(currentPath)) {
                console.log('[Auth PWA] Not authenticated in standalone mode, redirecting to login')
                
                // Track analytics if available
                if (app.$authAnalytics) {
                  app.$authAnalytics.trackCallback('pwa_standalone_redirect', null, new Error('Not authenticated'))
                }
                
                redirect('/auth/login/')
              }
            }
          } catch (error) {
            console.error('[Auth PWA] Error checking auth state:', error)
          }
        }, 500)
      }
    }, 100)

    // Clear interval after 5 seconds to prevent infinite loop
    setTimeout(() => {
      clearInterval(checkAuth)
    }, 5000)
  }

  // Initialize on client side
  if (process.client) {
    // Run after DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAuthCheck)
    } else {
      initAuthCheck()
    }
  }
}

